module.exports = __webpack_public_path__ + "img/g.7136763e.jpg";